import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_INCREMENTS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_INCREMENT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_INCREMENT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_INCREMENT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_INCREMENT:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
